<template>
 <MarketingShell>
 <div class="tm-integrated tm-paymentfailure">
  <div class="payment-result" :class="{ 'result-dark': isDark }">
    

    <div class="result-container">
      <div class="result-card">
        <div class="result-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none"
            stroke="#dc2626" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="15" y1="9" x2="9" y2="15" />
            <line x1="9" y1="9" x2="15" y2="15" />
          </svg>
        </div>
        <h2>Payment Failed</h2>
        <p>{{ message }}</p>
        <p class="sub-text">
          No money has been deducted from your account. You can try again
          or choose a different payment method.
        </p>
        <div class="btn-group">
          <button class="btn-retry" @click="$router.push('/pricing')">
            Try Again
          </button>
          <button class="btn-home" @click="$router.push('/')">
            Go Home
          </button>
        </div>
      </div>
    </div>
  </div>

 </div>
 </MarketingShell>
</template>

<script>
import MarketingShell from "./marketing/MarketingShell.vue";
export default {
  components: { MarketingShell },
  name: "PaymentFailure",
  computed: {
    isDark() {
      return this.$store.getters.isDarkTheme;
    },
    message() {
      const q = this.$route.query;
      return (
        q.error_Message ||
        q.error ||
        "Your payment could not be processed. Please try again."
      );
    },
  },
};
</script>

<style scoped>
.payment-result {
  min-height: 100vh;
  background: #fafaf8;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  color: #0f1923;
}

.result-nav {
  display: flex;
  align-items: center;
  padding: 0 48px;
  height: 56px;
  border-bottom: 1px solid #e8e5de;
}
.result-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: #0f1923;
}
.result-logo-img {
  height: 30px;
}
.result-logo-text {
  font-family: "DM Serif Display", serif;
  font-size: 18px;
}

.result-container {
  max-width: 480px;
  margin: 80px auto;
  padding: 0 24px;
}

.result-card {
  background: #fff;
  border: 1px solid #e8e5de;
  border-radius: 12px;
  padding: 48px 36px;
  text-align: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.04);
}

.result-card h2 {
  font-family: "DM Serif Display", serif;
  font-size: 24px;
  margin: 16px 0 8px;
}

.result-card p {
  font-size: 14px;
  color: #4a5568;
  margin: 0 0 8px;
}

.sub-text {
  font-size: 13px;
  color: #8a9aaa;
}

.btn-group {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 24px;
}

.btn-retry {
  padding: 12px 28px;
  background: #0f1923;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}
.btn-retry:hover {
  background: #16a34a;
}

.btn-home {
  padding: 12px 28px;
  background: transparent;
  color: #4a5568;
  border: 1.5px solid #d0ccc4;
  border-radius: 8px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
}
.btn-home:hover {
  border-color: #0f1923;
  color: #0f1923;
}

/* Dark theme */
.result-dark {
  background: #0c1018;
  color: #d1d4dc;
}
.result-dark .result-nav { border-bottom-color: rgba(55, 59, 75, 0.5); }
.result-dark .result-logo { color: #d1d4dc; }
.result-dark .result-card {
  background: #121826;
  border-color: rgba(55, 59, 75, 0.5);
  box-shadow: 0 1px 3px rgba(0,0,0,0.2), 0 8px 24px rgba(0,0,0,0.3);
}
.result-dark .result-card h2 { color: #e5e7eb; }
.result-dark .result-card p { color: #9ca3af; }
.result-dark .sub-text { color: #787b86; }
.result-dark .btn-retry { background: #e5e7eb; color: #0c1018; }
.result-dark .btn-retry:hover { background: #22c55e; color: #fff; }
.result-dark .btn-home { border-color: rgba(55, 59, 75, 0.6); color: #9ca3af; }
.result-dark .btn-home:hover { border-color: #d1d4dc; color: #e5e7eb; }
</style>
